module.exports = __webpack_public_path__ + "static/img/icon-ext.ba81b24c.png";